import request from 'superagent'
import types from '../types'

import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
let apiUrl = `${protocol}//${hostname}:${api_port}/api`
if(api_port==='') {
  apiUrl = `${protocol}//${hostname}/api`
}

const getStaffingModelRequested = () => ({
  type: types.GET_STAFFING_MODEL_REQUESTED,
  payload: null
})

const getStaffingModelRejected = (error: any) => ({
  type: types.GET_STAFFING_MODEL_REJECTED,
  payload: error
})

const getStaffingModelFulfilled = (data: any) => ({
  type: types.GET_STAFFING_MODEL_FULFILLED,
  payload: data
})

export const getStaffingModel = (token: string) => {
  return (dispatch: any) => {
    dispatch(getStaffingModelRequested())
    request
      .get(`${apiUrl}/staffingModel`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .then((response) => {
        dispatch(getStaffingModelFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getStaffingModelRejected(error))
      })
  }
}